import { CountriesEffects } from './countries/countries.effects';
import { DocumentIdEffects } from './document-id';
import { EnumsEffects } from './enumeration/enumeration.effects';
import { FeeQuoteEffects } from './fee-quote/fee-quote.effects';
import { LabelsEffects } from './labels/labels.effects';
import { LocationEffects } from './locations/location.effects';
import { QueryParamEffects } from './query-params/query-param.effects';
import { ServiceOptionsEffects } from './service-options/service-options.effects';
import { StatesEffects } from './states';
import { TransactionEffects } from './transaction';

export const AppEffects = [
  FeeQuoteEffects,
  ServiceOptionsEffects,
  LabelsEffects,
  TransactionEffects,
  QueryParamEffects,
  EnumsEffects,
  CountriesEffects,
  StatesEffects,
  DocumentIdEffects,
  LocationEffects,
];
